var __ = require('ramda/src/__');
var curry = require('ramda/src/curry');
var gt = require('ramda/src/gt');
var lt = require('ramda/src/lt');
var both = require('ramda/src/both');

/**
 * @signature Number -> Number -> Number -> Boolean
 */
var within = curry(function (start, end, value) {
  return both(gt(__, start), lt(__, end))(value);
});
module.exports = within;